import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-replacement-insurance-modal',
  templateUrl: './replacement-insurance-modal.component.html',
  styleUrl: './replacement-insurance-modal.component.css'
})
export class ReplacementInsuranceModalComponent {

  @Input() formNotValid: any;
  @Input() statusName: any;
  @Input() upsellCustomer: any;
  @Input() awaitingEscalation: any;
  @Input() identificationType: any;
  @Input() location: any;
  @Input() secondaryContactTelephone: any;
  @Input() resubmissionCount: any;
  @Input() rejectionInfo: any;
  @Input() customerDetailCheck: any;
  @Input() kycComponentModeEnum: any;
  @Input() componentMode: any;

  @Input() insurancePolicyFlag: boolean;
  @Output() isInsuranceDetailsValid = new EventEmitter<any>();
  dateTime: string = "2024-01-01T12:00"


  validateInsurance(check) {
    this.isInsuranceDetailsValid.emit(check);
  }

}
